import React from 'react';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import EditProfileForm from '../../components/EditProfileForm/EditProfileForm';

const EditProfilePage = props =>
  <LargePaper>
    <h1 style={stylesDefault.title}>Éditer son profil</h1>
    <EditProfileForm history={props.history}/>
  </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(EditProfilePage));



// WEBPACK FOOTER //
// ./src/containers/EditProfilePage/EditProfilePage.jsx